// extracted by mini-css-extract-plugin
export default {"component":"ConsultationFormsLayout_component__MpQHS","darkMode":"ConsultationFormsLayout_darkMode__Zbfoh"};